import { render, staticRenderFns } from "./product-options.vue?vue&type=template&id=2f2bbc05&scoped=true"
import script from "./product-options.vue?vue&type=script&lang=js"
export * from "./product-options.vue?vue&type=script&lang=js"
import style0 from "./product-options.vue?vue&type=style&index=0&id=2f2bbc05&prod&lang=scss"
import style1 from "./product-options.vue?vue&type=style&index=1&id=2f2bbc05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bbc05",
  null
  
)

export default component.exports